import { render, staticRenderFns } from "./legend.vue?vue&type=template&id=486e26c3&lang=pug&"
import script from "./legend.vue?vue&type=script&lang=js&"
export * from "./legend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports